import { IComponentNode, IPage } from 'app/app/editor/index.functions';
import { generateUid, processPageContainersUid } from 'app/app/editor/page/index';

export default function insertComponentIntoPage(
    scrPage: IPage,
    type: string,
    dropPath: Array<string>,
    componentAfterId: string,
    layout?: any,
): { newPage: IPage; uid: string } {
    const isContainer = type === 'container';
    const newPage = structuredClone(scrPage);

    let k = newPage.layout;
    let parentUid: string | undefined = undefined;

    for (const key of dropPath) {
        for (let j = 0; j < (k.elements?.length ?? 0); j++) {
            const element = k.elements?.[j];
            if (element && element.type === 'container' && 'mi-app-' + element.params.uid === key) {
                parentUid = element.params.uid;
                k = element;
                break;
            }
        }
    }

    if (!k.elements) k.elements = [];

    const uid = generateUid(newPage.components, type, parentUid, newPage.layout);

    const component = { component: type, settings: {} };
    if (!isContainer) newPage.components[uid] = component;

    const newElement: IComponentNode = {
        type: isContainer ? 'container' : 'component',
        params: { uid, layout: layout ?? {} },
    };

    const elUid = document.getElementById(componentAfterId)?.dataset['uid'] ?? '';
    const index = k.elements.findIndex((e: IComponentNode) => e?.params?.uid && e.params.uid === elUid);

    if (index > -1) k.elements.splice(index + 1, 0, newElement);
    else k.elements.unshift(newElement);

    processPageContainersUid(newPage.layout, 'container');

    const finalUid = newElement.params.uid;
    return { newPage, uid: finalUid };
}
